// import React, { useEffect, useState } from "react";
// import { mappls } from "mappls-web-maps";

// const AddProjectMap = ({ setData }) => {
//     useEffect(() => {
//         const initializeMap = async () => {
//             try {
//                 // Map Properties
//                 const mapProps = {
//                     center: [22.6708, 71.5724],
//                     traffic: false,
//                     zoom: 7,
//                     geolocation: false,
//                     clickableIcons: false,
//                 };

//                 // Initialize mappls
//                 const mapplsClassObject = new mappls();

//                 // Check if mapplsClassObject is initialized
//                 if (mapplsClassObject) {
//                     // Initialize mappls with API key
//                     mapplsClassObject.initialize("4b5d031b33d1a6ecb0ddbc322dc81ab4", () => {
//                         const map = mapplsClassObject.Map({ id: "map_", properties: mapProps });
//                         if (map) {
//                             let marker;

//                             // Add event listener for click on map
//                             map.on("click", (e) => {
//                                 const current = e.lngLat;
//                                 if (marker) {
//                                     marker.setPosition(current);
//                                 } else {
//                                     marker = mapplsClassObject.Marker({
//                                         map: map,
//                                         position: current,
//                                         clusters: false,
//                                     });
//                                 }

//                                 // Update the plocation field in the state correctly
//                                 setData((prevData) => ({
//                                     ...prevData,
//                                     plocation: `${current.lat}, ${current.lng}`,
//                                 }));
//                             });
//                         }
//                     });
//                 }
//             } catch (error) {
//                 console.error("Error initializing map:", error);
//             }
//         };

//         initializeMap();

//         // Cleanup function
//         return () => {
//             // Any cleanup code here if needed
//         };
//     }, [setData]);

//     return (
//         <div id="map_">
//             {/* This div is where the map will be rendered */}
//         </div>
//     );
// };

// export default AddProjectMap;


import React, { useEffect, useRef } from "react";

const AddProjectMap = ({ setData }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const mapId = useRef(`map_${Date.now()}`);

  useEffect(() => {
    let isMounted = true;
    const scriptId = "mappls-sdk-script";

    const loadMap = () => {
      if (!isMounted) return;

      if (!window.mappls || !window.mappls.Map) {
        console.log("Mappls SDK not loaded");
        return;
      }

      const mapDiv = document.getElementById(mapId.current);
      if (!mapDiv) return;

      mapDiv.innerHTML = "";

      const map = new window.mappls.Map(mapId.current, {
        center: {
          lat: 22.6708,
          lng: 71.5724,
        },
        zoom: 7,
        traffic: false,
        geolocation: false,
        clickableIcons: false,
      });

      mapRef.current = map;

      map.addListener("click", (e) => {
        const lat = e.lngLat.lat;
        const lng = e.lngLat.lng;

        if (markerRef.current) {
          markerRef.current.setPosition({ lat, lng });
        } else {
          markerRef.current = new window.mappls.Marker({
            map,
            position: { lat, lng },
          });
        }

        setData((prev) => ({
          ...prev,
          plocation: `${lat}, ${lng}`,
        }));
      });
    };

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://apis.mappls.com/advancedmaps/api/4b5d031b33d1a6ecb0ddbc322dc81ab4/map_sdk?layer=vector&v=3.0";
      script.async = true;
      script.defer = true;
      script.onload = loadMap;
      document.body.appendChild(script);
    } else {
      if (window.mappls?.Map) {
        loadMap();
      } else {
        document.getElementById(scriptId).onload = loadMap;
      }
    }

    return () => {
      isMounted = false;
      markerRef.current = null;
      mapRef.current = null;

      const mapDiv = document.getElementById(mapId.current);
      if (mapDiv) {
        mapDiv.innerHTML = "";
      }
    };
  }, [setData]);

  return (
    <div
      id={mapId.current}
      style={{
        width: "100%",
        height: "300px",
      }}
    />
  );
};

export default AddProjectMap;